import PropTypes from 'prop-types';
import '../assets/scss/backLink.scss';

const BackLink = ({ onNavigate, spacing = false }) => {
  return (
    <nav aria-label="Back link" id="backLink" className={spacing ? 'back-link--spacing' : ''}>
      <a
        href="#back"
        className="govuk-back-link"
        onClick={(e) => {
          e.preventDefault();
          onNavigate();
        }}
      >
        Back
      </a>
    </nav>
  );
};

export default BackLink;

BackLink.propTypes = {
  onNavigate: PropTypes.func.isRequired,
  spacing: PropTypes.bool,
};
